import api from "../../utils/Api";

const BackendAdminApiBaseUrl = process.env.REACT_APP_ADMIN_URL;
const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

const chatApi = {    
    async fetchUser(id){
        const response = await api.get( BackendAdminApiBaseUrl + '/message/userprofile/' + id);
        return response;
    },

    async fetchProfile(){
        const response = await api.get( BackendApiBaseUrl + '/profile/me');
        return response;
    },

    async fetchConversation(profileId, userId){
        const response = await api.get( BackendAdminApiBaseUrl + '/message/conversations/'+ profileId + '/' + userId);
        return response;
    },

    async fileUplaod(payload){
        const response = await api.post( BackendApiBaseUrl + '/upload', payload);
        return response;
    }
}

export default chatApi;